import { useState } from "react";
import { RegisterForm } from "./RegisterForm";
import { UinSuccess } from "./UinSuccess";

import { useI18n } from "../lib/i18n";

export const RegisterSection = ({ onRegistered }) => {
  const { t } = useI18n();
  const steps = t("regSteps").map(([title, desc], i) => [`0${i + 1}`, title, desc]);
  const [result, setResult] = useState(null);
  const done = (r) => { setResult(r); onRegistered?.(); };
  return (
    <section id="register" className="relative border-y border-[#30363D] bg-[#161B22]/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <p className="font-mono text-xs text-[#38BDF8]">{t("regEyebrow")}</p>
          <h2 data-testid="register-title" className="mt-2 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">{t("regTitle")}</h2>
          <p className="mt-4 text-[#8B949E] leading-relaxed">{t("regSub")}</p>
          <ol className="mt-10 space-y-8">
            {steps.map(([n, t, d]) => (
              <li key={n} className="flex gap-5">
                <span className="font-mono text-sm text-[#3FB950] pt-0.5">{n}</span>
                <div>
                  <p className="font-display font-semibold">{t}</p>
                  <p className="mt-1 text-sm text-[#8B949E] leading-relaxed">{d}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
        <div className="lg:col-span-7">
          <div className="rounded-2xl border border-[#30363D] bg-[#161B22]/80 backdrop-blur-xl p-6 sm:p-10 shadow-2xl shadow-black/40">
            {result ? <UinSuccess result={result} onReset={() => setResult(null)} /> : <RegisterForm onSuccess={done} />}
          </div>
        </div>
      </div>
    </section>
  );
};
